import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccountService from '../../services/account.service';
import { Modal, Button, Box, Typography, Alert } from '@mui/material';

const LiftSalesGateModal = ({ open, onClose, accountId, reason, gatedAt, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setError(null);
    onClose();
  };

  const handleLift = () => {
    setLoading(true);
    setError(null);
    AccountService.liftSalesGate(accountId)
      .then(() => {
        setLoading(false);
        onSuccess();
        handleClose();
      })
      .catch((err) => {
        setLoading(false);
        setError(err?.response?.data?.message || 'Error lifting sales gate.');
      });
  };

  const formattedGatedAt = gatedAt ? new Date(gatedAt).toLocaleString() : null;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 480,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Lift sales gate
        </Typography>

        <Alert severity="info" sx={{ mb: 2 }}>
          This will re-activate every product, price, and payment link that was disabled when the
          gate was applied (both in the database and in Stripe).
        </Alert>

        {(reason || formattedGatedAt) && (
          <Box sx={{ mb: 2 }}>
            {reason && (
              <Typography variant="body2">
                <b>Reason:</b> {reason}
              </Typography>
            )}
            {formattedGatedAt && (
              <Typography variant="body2">
                <b>Applied at:</b> {formattedGatedAt}
              </Typography>
            )}
          </Box>
        )}

        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={handleClose} disabled={loading}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleLift} disabled={loading}>
            Lift sales gate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

LiftSalesGateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  reason: PropTypes.string,
  gatedAt: PropTypes.string,
  onSuccess: PropTypes.func.isRequired
};

export default LiftSalesGateModal;
